"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var _default = exports.default = [{
  path: '/attendances',
  name: 'attendances',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/attendances/attendances/AttendancesPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/attendances/dashboard',
  name: 'attendances-dashboard',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/attendances/dashboard/DashboardPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/attendances/absences',
  name: 'attendances-absences',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/attendances/absences/AbsencesPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/attendances/punchs',
  name: 'attendances-punchs',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/attendances/punchs/PunchsPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/attendances/timesheets',
  name: 'attendances-timesheets',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/attendances/timesheets/TimesheetsPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/attendances/verified-photos',
  name: 'attendances-verified-photos',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/attendances/verifiedPhotos/VerifiedPhotosPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/attendances/devices',
  name: 'attendances-devices',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/attendances/devices/DevicesPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/attendances/settings',
  name: 'attendances-settings',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/attendances/settings/SettingsPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}];